module.exports = __webpack_public_path__ + "static/media/cartilla_medica_icon.af664106.svg";